import { lazy, Suspense, type PropsWithChildren } from "react";
import { ConsentProvider, pikbaseLegalConfig } from "@gsb-core/feature-legal";
import { browserConsentPersistence } from "./legal-config";

const LegalCookieConsent = lazy(() =>
  import("./legal-feature").then(({ legalFeatureModule }) => ({
    default: legalFeatureModule.components.CookieConsent,
  })),
);

export function LegalProvider({ children }: PropsWithChildren) {
  return (
    <ConsentProvider
      adapter={browserConsentPersistence}
      policyVersion={pikbaseLegalConfig.policyVersion}
      storageKey={pikbaseLegalConfig.consentStorageKey}
      delayMs={pikbaseLegalConfig.consentDelayMs}
      categories={pikbaseLegalConfig.consent.categories}
    >
      {children}
    </ConsentProvider>
  );
}

export function LazyLegalCookieConsent() {
  return (
    <Suspense fallback={null}>
      <LegalCookieConsent />
    </Suspense>
  );
}
